<template>
  <content-view>
    <div class="allocate">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="选择商品出库仓库：" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-select
            v-decorator="['outStoreId',{rules: [{ required: true, message: '请选择商品出库仓库'}]}]"
            placeholder="请选择"
            @change="changeStore"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in wareHouseList"
              :key="index"
            >{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="选择商品入库仓库：" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-select
            v-decorator="['inStoreId',{rules: [{ required: true, message: '请选择商品入库仓库'}]}]"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in wareHouseList"
              :key="index"
            >{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="商品使用类型：" :label-col="{ span: 6 }" :wrapper-col="{ span: 6 }">
          <a-radio-group @change="onChangeType" v-decorator="['useType',{initialValue: 1}]">
            <a-radio :value="1">售卖</a-radio>
            <a-radio :value="2">自用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="调拨商品名称、数量："
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 6 }"
          v-for="(item, index) in addTrade"
          :key="index"
        >
          <!-- <a-select
            v-decorator="['tradeName' + item.index,{rules: [{ required: true, message: '请选择调拨商品'}]}]"
            placeholder="请选择"
            @change="changeGoods"
          >
            <a-select-option
              v-for="(item1) in item.options"
              :key="item1.id"
              :value="item1.id+'?='+item1.num+'?='+index"
            >{{item1.name}}（库存量{{item1.num}}）</a-select-option>
          </a-select> -->
          <a-select
            showSearch
            v-decorator="['tradeName' + item.index, {rules: [{ required: true, message: '请选择调拨商品'}]}]"
            placeholder="请选择"
            @change="changeGoods"
            @search="searchGoods"
            :defaultActiveFirstOption="false"
            :showArrow="false"
            :filterOption="false"
            :notFoundContent="null"
          >
            <a-select-option
              v-for="(item1) in item.options"
              :key="item1.id"
              :value="item1.id+'?='+item1.num+'?='+index"
            >{{item1.name}}（库存量{{item1.num}}）</a-select-option>
          </a-select>
          <a-input-number
            :max="item.num"
            :min="0"
            placeholder="请输入数量"
            class="enterNumber ant-col-6"
            v-model="tradeNumber[index]"
          />
          <div class="extra_action">
            <a href="javascript:;" v-if="index == 0" @click="addNewTrade">继续添加商品</a>
            <a-divider type="vertical" v-if="index == 0"/>
            <a href="javascript:;" @click="delectTrade(index)">删除</a>
          </div>
        </a-form-item>
        <a-form-item label="申请原因：" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-textarea
            placeholder="请输入"
            :autosize="{ minRows: 2, maxRows: 12 }"
            v-decorator="['reason',{rules: [{ required: true, message: '请输入申请原因'}]}]"
          />
        </a-form-item>
        <a-form-item label="审核人职位：" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-select
            v-decorator="['approvalRoleId',{rules: [{ required: true, message: '请选择审核人职位'}]}]"
            placeholder="请选择"
            @change="changeRole"
          >
            <a-select-option
              :value="item.id"
              v-for="item in comfirmRoleList"
              :key="item.id"
            >{{item.roleName}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="审核人：" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-select
            v-decorator="['approvalUserId',{rules: [{ required: true, message: '请选择审核人'}]}]"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.id"
              v-for="item in comfirmMemberList1"
              :key="item.id"
            >{{item.username}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="text-center">
          <a-button @click="$router.go(-1)">取消</a-button>
          <a-button type="primary" html-type="submit">发起审核</a-button>
        </a-form-item>
      </a-form>
    </div>
  </content-view>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex';
  export default {
      name: 'allocate',
      components: {},
      props: {},
      data() {
          return {
              addTrade: [
                  {
                      index: 1,
                      options: [],
                      num: 1
                  }
              ],
              form: this.$form.createForm(this),
              tradeNumber: [],
              comfirmRoleList: [],
              comfirmMemberList: [],
              comfirmMemberList1: [],
              wareHouseList: [],
              goodsLists: [],
              warehouseId: undefined,
              useType: 1
          };
      },
      computed: {
          ...mapGetters(['shopId'])
      },
      methods: {
          changeRole(e) {
              this.comfirmMemberList1 = this.comfirmMemberList.filter(el => {
                  return el.roleId == e;
              });
          },
          handleSubmit(e) {
              e.preventDefault();
              this.form.validateFields((err, values) => {
                  if (!err) {
                      if (values.inStoreId === values.outStoreId) {
                          this.$message.error(
                              '出库仓库不能与入库仓库一致，请重新选择'
                          );
                          return false;
                      }
                      var list = {
                          approvalRoleId: values.approvalRoleId,
                          approvalUserId: values.approvalUserId,
                          outStoreId: values.outStoreId,
                          inStoreId: values.inStoreId,
                          reason: values.reason,
                          goodsList: []
                      };
                      values.tradeNumber = this.tradeNumber;
                      for (let i = 0; i < this.tradeNumber.length; i++) {
                          if (
                              values[`tradeName${i + 1}`] ===
                              values[`tradeName${i}`]
                          ) {
                              this.$message.error(
                                  '调拨出库商品不能重复，请重新选择'
                              );
                              return false;
                          }
                          if (!this.tradeNumber[i]) {
                              this.$message.error('请输入调拨数量');
                              return false;
                          }
                          list.goodsList.push({
                              id: values[`tradeName${i + 1}`].split('?=')[0],
                              num: this.tradeNumber[i],
                              currentInventory: Number(
                                  values[`tradeName${i + 1}`].split('?=')[1]
                              )
                          });
                      }
                      this.transfers(list);
                  }
              });
              this.auditVisible = true;
          },
          getGoods() {
              if (!this.warehouseId) {
                  this.$message.warning('请选择出库仓库');
                  return false;
              }
              // this.$api.storage
              //     .wareGoodsList({
              //         params: {
              //             warehouseId: this.warehouseId,
              //             useType: this.useType
              //         }
              //     })
              //     .then(res => {
              //         this.goodsLists = res;
              //         for (let i in this.addTrade) {
              //             this.addTrade[i].options = res;
              //         }
              //     });
          },
          // 切换仓库时改变该仓库里的商品
          changeStore(e) {
              this.warehouseId = e;
              this.getGoods();
          },
          // 切换售卖和自用，加载对应的商品下拉
          onChangeType(val) {
              this.useType = val.target.value;
              this.getGoods();
          },
          // 添加商品
          addNewTrade() {
              this.addTrade.push({
                  index: this.addTrade[this.addTrade.length - 1].index + 1,
                  options: this.goodsLists,
                  num: 1
              });
          },
          // 删除商品
          delectTrade(index) {
              this.addTrade.splice(index, 1);
              this.tradeNumber.splice(index, 1);
          },
          //审核人职位
          comfirmRole() {
              this.$api.storage
                  .comfirmRole({
                      params: { shopId: this.shopId }
                  })
                  .then(res => {
                      this.comfirmRoleList = res;
                      this.comfirmMember();
                  });
          },
          //审核人
          comfirmMember() {
              if (!this.shopId) return;
              this.$api.storage
                  .comfirmMember({
                      params: {
                          shopId: this.shopId
                      }
                  })
                  .then(res => {
                      this.comfirmMemberList = res;
                  });
          },
          //商品调拨接口
          transfers(params) {
              this.$api.storage.transfers({ body: params }).then(res => {
                  this.$message.success(
                      '已成功发起审核，可在审核管理中查看审核状态'
                  );
                  this.$router.go(-1);
              });
          },
          //仓库名称
          getWarehouseList() {
              if (!this.shopId) return;
              this.$api.storage
                  .getWarehouseList({
                      params: {
                          shopId: this.shopId
                      }
                  })
                  .then(res => {
                      this.wareHouseList = res;
                  });
          },
          // 切换出库商品时 拿到该商品的可出库最大值
          changeGoods(e) {
              this.addTrade[Number(e.split('?=')[2])].num = Number(
                  e.split('?=')[1]
              );
          },
          searchGoods(goodsName) {
            if (!this.warehouseId) {
                  this.$message.warning('请选择出库仓库');
                  return false;
              }
              if (!goodsName) {
                this.addTrade = [
                  {
                      index: 1,
                      options: [],
                      num: 1
                  }
                ]
                return;
              }
              this.$api.storage
                  .SearchWareGoodsList({
                      body: {
                          goodsName: goodsName,
                          pageNum: 1,
                          pageSize: 9999,
                          shopId: this.$store.getters.shopId,
                          useType: this.useType,
                          warehouseId: this.warehouseId
                      }
                  })
                  .then(res => {
                      this.goodsLists = res;
                      for (let i in this.addTrade) {
                          this.addTrade[i].options = res;
                      }
                  });
          }
      },
      created() {},
      mounted() {
          this.getWarehouseList();
          this.comfirmRole();
      },
      watch: {
          shopId() {
              this.form.setFieldsValue({
                  ['outStoreId']: '',
                  ['inStoreId']: '',
                  ['approvalUserId']: ''
              });
              this.getWarehouseList();
              this.comfirmRole();
          }
      }
  };
</script>
<style lang="scss">
  .allocate {
      background-color: #fff;
      padding: 24px 32px;
      border-radius: 2px;
      .extra_action {
          position: absolute;
          left: 220%;
          top: 0;
          width: 280px;
          a {
              color: #f57f25;
              font-size: 14px;
              text-decoration: #f57f25;
          }
      }
  }
  .auditInfo {
      display: flex;
      flex-direction: column;
      align-items: center;
      button {
          margin-top: 20px;
      }
  }
  .enterNumber {
      width: 100%;
      position: absolute;
      margin-left: 40px;
  }
</style>